{
  "next": "Neste",
  "previous": "Forrige"
}
